import { GET, POST, PATCH, DELETE } from '@/shared/api/requests';

export const getPhotoHotspots = async (photoId: number) => {
  const response = await GET(`/photos/${photoId}/hotspots/`);
  return response.data;
};

export const createHotspot = async (
  photoId: number,
  position: { pitch: number; yaw: number; hfov: number }
) => {
  return (await POST(`/photos/${photoId}/hotspots/`, position, { 'Content-Type': 'application/json' })).data;
};

export const updateHotspot = async (
  hotspotId: number,
  data: { title?: string | null; pitch?: number; yaw?: number; hfov?: number },
  projectId: string
) => {
  return (
    await PATCH(`/hotspots/${hotspotId}/?project_id=${projectId}`, data, {
      'Content-Type': 'application/json',
    })
  ).data;
};

export const deleteHotspot = async (hotspotId: number, projectId: string) => {
  return (await DELETE(`/hotspots/${hotspotId}/?project_id=${projectId}`)).data;
};

export const getHotspotOverlays = async (hotspotId: number) => {
  return (await GET(`/hotspots/${hotspotId}/overlays/`)).data;
};

export const getLayoutHotspots = async (layoutId: string) => {
  const res = await GET(`/layouts/${layoutId}/hotspots/`);
  const data = res?.data;
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object' && Array.isArray((data as { results?: unknown }).results)) {
    return (data as { results: unknown[] }).results;
  }
  return [];
};

export const getPaginatedHotspots = async (
  projectId: string,
  page: number = 1,
  pageSize: number = 20,
  search?: string
) => {
  const params = new URLSearchParams({
    project_id: projectId,
    paginate: 'true',
    page: page.toString(),
    page_size: pageSize.toString(),
  });
  if (search?.trim()) params.set('search', search.trim());
  return (await GET(`/hotspots/?${params.toString()}`)).data;
};

export const createNote = async (noteData: {
  hotspot: number;
  title: string;
  subject: string;
  description: string;
  reminder_date?: string | null;
  reminder_time?: string | null;
  reminder_message?: string;
  visible_to?: string[];
}) => {
  return (await POST(`/notes/`, noteData, { 'Content-Type': 'application/json' })).data;
};

export const updateNote = async (
  noteId: number,
  noteData: {
    title: string;
    subject: string;
    description: string;
    reminder_date?: string | null;
    reminder_time?: string | null;
    reminder_message?: string;
    visible_to?: string[];
  },
  projectId: string
) => {
  return (await PATCH(`/notes/${noteId}/?project_id=${projectId}`, noteData, { 'Content-Type': 'application/json' })).data;
};

export const deleteNote = async (noteId: number, projectId: string) => {
  return (await DELETE(`/notes/${noteId}/?project_id=${projectId}`)).data;
};

export const createNoteAttachment = async (noteId: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('note', noteId.toString());
  return (await POST(`/note-attachments/`, formData)).data;
};
